import _ from "lodash";
import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import Frame from "react-frame-component";
import parse from "html-react-parser";
import SizeSelector from "../utils/size-selector";
//import "./banner.css";

const Banner = ({ banner, selectors }) => {
  const template = useSelector((state) => state.template);

  const [html, setHtml] = useState("");
  const [css, setCss] = useState("");

  const transformCode = useCallback(
    async (code, set, flag) => {
      if (!banner.fields) return code;
      let obj = banner.fields;
      const contentUrl = "{{contentUrl}}/";
      code = code.replace(new RegExp(contentUrl, "g"), "");
      code = code.replace("{{url}}", banner.url);
      await Object.keys(obj).forEach((key) => {
        let str = `{{${key}}}`;
        if (typeof obj[key] !== "string") {
          let path = obj[key].path;
          if (code) code = code.replace(new RegExp(str, "g"), path);
        } else {
          let txt = obj[key];
          if (code) code = code.replace(new RegExp(str, "g"), txt);
        }
      });
      set(code);
    },
    [banner]
  );

  useEffect(() => {
    if (banner.fields) {
      const code = _.find(template.contents, ["type", "HTML"]);
      transformCode(code.body, setHtml);
    }
  }, [template, banner, transformCode]);

  useEffect(() => {
    if (banner.fields) {
      const styles = _.find(template.contents, ["type", "CSS"]);
      if (styles) setCss(styles.body);
    }
  }, [template, banner]);

  // {ReactHtmlParser(html)}

  return (
    <SizeSelector selectors={selectors}>
      <Frame
        initialContent={`<!DOCTYPE html><html><head><meta name="viewport" content="width=device-width" /><style>${css}</style></head><body><div id="bannerFrame"></div></body></html>`}
        mountTarget="#bannerFrame"
      >
        <>{parse(html)}</>
      </Frame>
    </SizeSelector>
  );
};

export default Banner;
